import { Stack, TextField } from "@mui/material";
import { TrailerEvent, TrailerEventType } from "../../../graphql/generated";
import EnumSelect from "../../common/EnumSelect";
import { DateTimePicker } from "@mui/x-date-pickers";

export default function TrailerEventForm({
  trailerEvent,
  onChange,
}: {
  trailerEvent?: Partial<TrailerEvent> | null;
  onChange: (event: Partial<TrailerEvent>) => void;
}) {
  return (
    <Stack spacing={2}>
      <EnumSelect data-testid="trailer-event-form-trailer-event-type"
        label="Type"
        enumObject={TrailerEventType}
        value={trailerEvent?.type || null}
        onChange={(event, type) => {
          if (!type) {
            return;
          }
          onChange({ ...trailerEvent, type });
        }}
      />
      <DateTimePicker
        label="Date"
        ampm={false}
        value={trailerEvent?.date || null}
        onChange={(date) => {
          onChange({ ...trailerEvent, date });
        }}
        renderInput={(params) => <TextField {...params} />}
      />
    </Stack>
  );
}
